import type { Article } from "@/types/film";

export const articles: Article[] = [
  {
    id: "a-01",
    title: "《母亲的第二次告别》：当记忆开始背叛爱",
    author: "沈砚秋",
    date: "2024-11-08",
    filmId: "second-farewell",
    filmTitle: "母亲的第二次告别",
    tag: "家庭伦理",
    excerpt:
      "阿尔茨海默症不是这部电影真正的主题，真正被追问的是：当一个人不再记得你，你们之间的责任还成立吗？影片用三次告别给出了自己的答案。",
    content: [
      "《母亲的第二次告别》最动人的地方，在于它拒绝把遗忘拍成一种煽情。镜头始终保持着近乎冷静的距离：母亲把女儿认成自己的妹妹，女儿没有反驳，只是顺着话题继续往下说。",
      "第一次告别发生在确诊那天，第二次发生在母亲忘记女儿名字的那个清晨，第三次则发生在她终于平静地说出「谢谢你，姑娘」的时候。三次告别层层递进，把亲情从血缘的理所当然，还原成一次次重新选择的结果。",
      "影片的伦理锋芒藏在日常里。长女主张把母亲送到专业机构，次子坚持留在家中照护，争执没有反派，只有两个都被生活压到极限的人。导演让争吵发生在厨房，背景是还没洗完的碗，这种琐碎的现场感让所有道德判断都变得迟疑。",
      "最后一镜里，女儿学着母亲的语气给窗台的花浇水。记忆可以被抹去，但被照料过的习惯会留下来。这大概是影片最温柔的伦理立场：爱不是记住，而是持续地做同一件事。",
    ],
  },
  {
    id: "a-02",
    title: "《屋檐之下》：一部关于「不离开」的家庭剧",
    author: "何嘉言",
    date: "2024-09-24",
    filmId: "under-eaves",
    filmTitle: "屋檐之下",
    tag: "剧集解析",
    excerpt:
      "十集，一个屋檐，四代人。它几乎不拍外面的世界，却把整个社会的压力都逼进了那间十二叠的客厅。这是一部关于忍耐的剧，也是一部关于忍耐极限的剧。",
    content: [
      "《屋檐之下》的空间设计是它最大的叙事武器。全剧九成场景发生在同一栋老屋，走廊的宽度、楼梯的吱呀声、厨房的抽油烟机，构成了人物关系的物理地图。",
      "它最锋利的地方在于，没有一个角色是坏人。婆婆的控制欲来自她被控制的一生，儿媳的沉默来自她无处安放的疲惫，丈夫的和稀泥来自他从小被教会「不要惹事」。伦理困境在这里不是选择对错，而是每个人都在用自己能承受的方式活下去。",
      "第八集的餐桌长镜头值得反复观看：一家人吃饭，没有人说话，只有筷子的声音。镜头缓慢地绕着桌子转了一圈，观众突然意识到，这张桌子上的每个人都在等别人先开口。",
      "结局没有和解的拥抱。老屋被卖掉了，一家人各自搬进新的公寓。这不是失败，而是一种诚实的处理：有些关系不需要被修复，只需要被允许改变形态。",
    ],
  },
  {
    id: "a-03",
    title: "《暗流》：真相的代价由谁承担",
    author: "周慕之",
    date: "2024-08-15",
    filmId: "undercurrent",
    filmTitle: "暗流",
    tag: "悬疑伦理",
    excerpt:
      "这部十二集剧集把「查真相」拍成了一种道德负债。每揭开一层，就有一个普通人被卷进去。它真正问的是：我们有权知道一切吗？",
    content: [
      "《暗流》的叙事结构像一次缓慢的退潮：先是露出一块礁石，然后是一整片沉船。剧集并不急于给出凶手，它更在意每个知情者在压力下如何变形。",
      "女主角作为一名调查记者，她的职业伦理与个人情感不断冲突。第六集里，她为了保护线人而放弃了足以定案的证据，这个选择在剧中既没有被赞扬，也没有被谴责，只是被安静地记录下来。",
      "该剧对「旁观者」的描写尤其精准。邻居、同事、物业、甚至只出现过一场戏的快递员，都构成了一张共谋的网。导演用大量固定镜头拍摄走廊与楼道，人被困在画框里，暗示着每个人都无处可退。",
      "结尾的处理克制得近乎残忍：真相公开了，但没有人因此变得更好。这或许是近年来国产伦理悬疑剧最有勇气的一次收尾。",
    ],
  },
  {
    id: "a-04",
    title: "《静默之潮》：沉默是一种共谋",
    author: "林知远",
    date: "2024-06-30",
    filmId: "silent-tide",
    filmTitle: "静默之潮",
    tag: "电影解析",
    excerpt:
      "一个海边小镇，一桩被所有人默认的旧事。影片用极少的对白与大量的环境音，拍出了集体沉默如何缓慢地腐蚀一个家庭。",
    content: [
      "《静默之潮》开场有整整三分钟没有台词，只有潮水、风声和远处渔船的引擎。这种耐心奠定了全片的基调：它不解释，它让你待在那里。",
      "影片的核心冲突并不激烈，甚至可以说是「什么都没发生」。父亲知道儿子做了什么，母亲知道父亲知道，邻居们知道这一家人知道。所有人都在维持一个体面的表面。",
      "导演大量使用门框与窗框构图，让人物总被切割。女儿最终选择离开小镇的那场戏，她第一次走出画框，走向镜头外的海。这是全片唯一一次「越界」，也是唯一一次自由。",
      "伦理题材最难的是不说教，这部电影做到了。它没有给出惩罚，也没有给出原谅，只是让沉默的重量被完整地看见。",
    ],
  },
  {
    id: "a-05",
    title: "《白露为霜》：亲密关系里的隐形暴力",
    author: "苏禾",
    date: "2024-05-12",
    filmId: "white-dew",
    filmTitle: "白露为霜",
    tag: "性别议题",
    excerpt:
      "没有一巴掌落在脸上，没有一句脏话被喊出来。这部电影用最温和的语气，拍出了最令人窒息的亲密关系。",
    content: [
      "影片中的丈夫体贴、体面、事业有成，从不发火。他只是会在妻子出门前轻声说一句「你确定要穿这件吗」，然后把所有决定都替她做完。",
      "导演用光线完成了一次隐喻：家里的灯永远是暖黄的，但窗外的自然光被厚厚的窗帘挡在外面。女主人公的脸始终处在一半阴影里，直到她第一次独自打开窗帘。",
      "台湾电影处理此类题材时的那种细密，在本片里体现得非常充分。母女两代人的对照让议题从个人扩展到结构：母亲那代人把忍耐当成美德，女儿这代人则要面对「你明明可以走」的新压力。",
      "结尾没有戏剧性的反抗，只有一次安静的搬家。她带走了自己的书和那盆白露时节的兰花。这个克制的结尾，比任何控诉都更有力。",
    ],
  },
  {
    id: "a-06",
    title: "《第四面墙》：当家庭成为一间审讯室",
    author: "陈默",
    date: "2024-03-18",
    filmId: "fourth-wall",
    filmTitle: "第四面墙",
    tag: "电影解析",
    excerpt:
      "影片把香港的一间旧公寓拍成了舞台。四个人物，一块不存在的第四面墙，观众被迫成为这场家庭审判的旁听者。",
    content: [
      "《第四面墙》的片名既是戏剧术语，也是心理隐喻。父亲是一位过气的话剧演员，他把整个家当成自己的舞台，每个人都被分配了角色。",
      "摄影机几乎不离开公寓，镜头高度始终保持在人的视线水平，观众像是坐在客厅的第五把椅子上。这种设计让偷窥感与共犯感同时成立。",
      "影片中段有一场长达十四分钟的争吵，没有任何剪辑。演员的呼吸、停顿、甚至一次倒水的声音都被完整保留，情绪在长镜头里层层堆叠，直到某一刻突然断裂。",
      "最后一幕，父亲对着镜子念台词，镜子里却没有观众。这个画面几乎概括了所有控制型亲子关系的悲剧：他一生都在表演，却从未真正被看见。",
    ],
  },
  {
    id: "a-07",
    title: "《失语的证人》：沉默的人有没有罪",
    author: "高远",
    date: "2024-02-05",
    filmId: "mute-witness",
    filmTitle: "失语的证人",
    tag: "悬疑伦理",
    excerpt:
      "一个聋哑目击者，一桩找不到证据的案件。韩国导演朴正元用近乎纪录片的冷静，追问目击与作证之间的伦理距离。",
    content: [
      "影片最有力量的部分，是对「证词」这件事的拆解。手语翻译在法庭上并不是中立的，她的措辞、语序、甚至表情，都会改变证词的重量。",
      "导演刻意保留了翻译过程的延迟感。每一次对话都要等两遍，这种节奏让观众体会到沟通本身的成本，也让真相显得更加遥不可及。",
      "主人公并非完美受害者，他曾因为害怕而选择沉默，这个选择在影片后段被反复审视。影片拒绝把他塑造成英雄，只把他还原成一个在恐惧与良知之间摇摆的普通人。",
      "结尾字幕交代了案件的真实结局，很短，只有两行。但正是这两行冷静的文字，让前面两小时的情绪有了落点。",
    ],
  },
];